import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button, scrollToPurchase } from './ui/Button';
import { IMAGES, heroBenefits } from '../data/content';
export function Hero() {
  return <section className="bg-fil-card px-4 sm:px-6 lg:px-8 pt-8 pb-12 lg:pt-14 lg:pb-16" data-id="element-74" data-mp="9llb731mq8q5">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-[1fr_1fr] lg:gap-14" data-id="element-75" data-mp="4mrt0xbedtjn">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-1 lg:row-start-1 lg:self-end text-center lg:text-left" data-id="element-76" data-mp="12a0l5b5wm0um">
          

          <h1 className="text-[2rem] leading-[1.12] sm:text-5xl lg:text-[3.4rem] font-bold text-fil-text mb-4" data-id="element-77" data-mp="ncq29gqxlsov">
            Aprende{' '}
            <span className="text-fil-terra" data-id="element-78" data-mp="3d33fj0i70xlt">Filigrana de Papel</span> desde
            cero y crea piezas increíbles
          </h1>

          <p className="text-base sm:text-lg text-fil-taupe leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-79" data-mp="3j8iyd2s0imwa">
            Descubre paso a paso cómo transformar simples tiras de papel en
            flores, animales, letras, cuadros, tarjetas y decoraciones llenas
            de detalles, incluso si nunca has practicado filigrana.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-2 lg:row-start-1 lg:row-span-2 lg:self-center my-8 lg:my-0" data-id="element-80" data-mp="3e7uwfm28wlna">
          <img src={IMAGES.portada} alt="Portada del curso El Arte de la Filigrana, de Deco Emprende" className="w-full max-w-xs sm:max-w-sm lg:max-w-none mx-auto h-auto" data-id="element-81" data-mp="2qhqvjmgfyzzz" />
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-82" data-mp="2hl9sz7m58afu">
          <ul className="grid sm:grid-cols-2 gap-2.5 mb-8 max-w-xl mx-auto lg:mx-0 text-left" data-id="element-83" data-mp="2ljgyf6b5ppbq">
            {heroBenefits.map(benefit => <li key={benefit} className="flex items-center gap-2.5 bg-fil-bg border border-fil-beige rounded-2xl px-4 py-3" data-id="element-84" data-mp="s3co0h6r7vtq">
                <span className="w-6 h-6 rounded-full bg-fil-sage/30 text-fil-sage-dark flex items-center justify-center shrink-0" data-id="element-85" data-mp="ic889f9986xu">
                  <CheckIcon size={14} strokeWidth={3} data-id="element-86" data-mp="de6oes4083lb" />
                </span>
                <span className="text-sm font-medium text-fil-text" data-id="element-87" data-mp="1b1ffr3qos6v8">
                  {benefit}
                </span>
              </li>)}
          </ul>

          <div className="text-center lg:text-left" data-id="element-88" data-mp="162lz52g3rzqu">
            <p className="text-xs sm:text-sm text-fil-muted font-medium mt-4" data-id="element-89" data-mp="111yc0ruzw31w">
              Curso 100% digital · Acceso inmediato
            </p>
          </div>
        </div>
      </div>
    </section>;
}